// extracted by mini-css-extract-plugin
export default {"errorWrap":"error_errorWrap__-DBbC","errorTitle":"error_errorTitle__iuxpV","errorSubTitle":"error_errorSubTitle__gdlI0"};